import { Picture } from '@ui';
import type { FC } from 'react';
import { memo } from 'react';
import { Link } from '@compat/router';
import icons from '@icons';

const {
  bar: { black: barBlackOutlined }
} = icons.Outline;

const BarBtn: FC = () => (
  <Link
    to='/ustrichnye-bary-v-moskve'
    className='flex items-center gap-0.5 h-[21px] font-medium text-sm bg-[#FFEA81] leading-none p-0.5 rounded'
  >
    <Picture icon={barBlackOutlined} width={14} height={14} />
    <span>Бары</span>
  </Link>
);

export default memo(BarBtn);
